import { ApiClient } from "./clients";
import { Money } from "./models/common/Money";
import { UuidResult } from "./models/common/UuidResult";
import { InvestmentConfirmationV2 } from "./models/investment/InvestmentConfirmationV2";
import { InvestmentConfirmationStepType } from "./enums/InvestmentConfirmationStepType";

export type InvestmentConfirmationSignatureV2 = {
  documentType: InvestmentConfirmationStepType | string;
  signature?: string;
};

export type InvestmentConfirmationExternalSignatureV2 = {
  documentType: InvestmentConfirmationStepType | string;
  signatureFile: string;
  file: string;
};

export type SigningErrorReportV2 = {
  signMethod: "sms" | "ecp" | "goskey";
  errorMessage: string;
  documentType?: InvestmentConfirmationStepType | string;
  documentName?: string;
  errorCode?: string;
  screenshot?: string;
  signatureFileName?: string;
  signatureFile?: string;
};

export class InvestmentManagerV2 {
  constructor(private readonly apiClient: ApiClient) {}

  createConfirmation(projectUuid: string, money: Money): Promise<UuidResult> {
    return this.apiClient.post("/confirmation", { projectUuid, money });
  }

  getConfirmation(confirmationUuid: string): Promise<InvestmentConfirmationV2> {
    return this.apiClient.get(`/confirmation/${confirmationUuid}`);
  }

  sendConfirmationCode(
    confirmationUuid: string,
    codeUuid?: string
  ): Promise<void> {
    return this.apiClient.post(`/confirmation/${confirmationUuid}/send-code`, {
      codeUuid,
    });
  }

  sign(
    confirmationUuid: string,
    signatures: InvestmentConfirmationSignatureV2[],
    code?: string,
    codeUuid?: string
  ): Promise<void> {
    return this.apiClient.post(`/confirmation/${confirmationUuid}/sign`, {
      signatures,
      code,
      codeUuid,
    });
  }

  externalSign(
    confirmationUuid: string,
    signatures: InvestmentConfirmationExternalSignatureV2[]
  ): Promise<void> {
    return this.apiClient.post(
      `/confirmation/${confirmationUuid}/external-sign`,
      {
        signatures,
      }
    );
  }

  create(confirmationUuid: string): Promise<UuidResult> {
    return this.apiClient.post("", { confirmationUuid });
  }

  reportSigningError(
    confirmationUuid: string,
    report: SigningErrorReportV2
  ): Promise<void> {
    return this.apiClient.post(
      `/confirmation/${confirmationUuid}/signing-error`,
      report
    );
  }
}
